import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricPopularHotelKayak extends MetricBase {
    constructor() {
        super({
            field: "metric_popular_hotel",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.kayak.popularHotel.chartName"),
            serieLabel: i18n.t("metrics.kayak.popularHotel.serieLabel"),
            tooltip: i18n.t("metrics.kayak.popularHotel.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricPopularHotelKayak;
